// extracted by mini-css-extract-plugin
export default {"result":"ResultAlert_result__3eo5p","button":"ResultAlert_button__hQW6L","platform":"ResultAlert_platform__5qrcX","blue":"ResultAlert_blue__u3Sic","red":"ResultAlert_red__NpwFR"};